export class FaaImportExecution {
  startedAt: Date = null;
}
